module.exports = __webpack_public_path__ + "img/A1M7.7bc4b691.jpg";